/* eslint-disable array-callback-return */
import { React } from "mondrian-react";
import FaturaForm from "modules/FaturaForm";
import PageContainer from "components/Container";
import { acessarFaturas } from "modules/FaturaForm/actions";
import faturaInvoicesMockup from "utils/mockups/fatura-invoices";
import { logger } from "utils/logger";
import { sendTokenCode } from "modules/CodeAuthenticationModal/actions";
import { ErrorFatura } from "utils/errorFatura";
import { Dialog } from "components/Dialog";
import { handleMesMask } from "utils/handleMesMask";
import { setCookie } from "utils/cookie";
import useIsTotem from "hooks/useIsTotem";
import { reportGA4 } from "utils/pushDataLayer";

const isDev = process.env.NODE_ENV === "development";

const PageFaturaFacil = () => {
  const [isLoading, setLoading] = React.useState(false);
  const [isNew, setNew] = React.useState(false);
  const [listInvoices, setInvoices] = React.useState([]);
  const [lineSelected, setMsisdn] = React.useState("");
  const [tokenRecaptcha, setTokenRecaptcha] = React.useState();
  const [otpTransactionId, setOtpTransactionId] = React.useState();
  const [currentStep, setCurrentStep] = React.useState(0);
  const [isEmpty, setIsEmpty] = React.useState(false);
  const [isPhoneError, setIsPhoneError] = React.useState(false);
  const [dialogObject, setDialogObject] = React.useState({
    title: "",
    description: [],
    function: () => {},
    isOpen: false,
    botao: undefined,
  });

  const isTotem = useIsTotem();
  React.useEffect(() => {
    if (isTotem) {
      setCookie("is-totem", isTotem, 1);
    } else {
      setCookie("is-totem", "", 0);
    }
  });

  React.useEffect(() => logger({ name: "LoadPage" }), []);

  const handleButtonVoltar = () => {
    logger({ name: "ConsultarOutroSemFatura" });
    setCurrentStep(0);
    setIsEmpty(false);
    setIsPhoneError(false);
    setMsisdn("");
    setDialogObject({
      title: "",
      description: [],
      function: () => {},
      isOpen: false,
    });
  };

  const handleAcessarFaturas = (
    msisdn,
    tokenRecaptcha,
    otpToken,
    otpTokenTrasactionId
  ) => {
    msisdn = msisdn.replace(/[^0-9]/g, "");
    setNew(true);
    setLoading(true);
    logger({ name: "GetInvoices" });
    if (isDev) {
      //erro de cliente multi
      // const data = {
      //   success: {
      //     fault: {
      //       erro: {
      //         error: {
      //           detailedMessage: "Cliente não pode ser COMBO_MULTI_NET.",
      //           errorCode: "MS-AA-EASTINVOICES-SERVICE-007",
      //           httpCode: "422",
      //           message: "Unprocessable Entity",
      //         },
      //       },
      //     },
      //   },
      // };
      // erro sem fatura
      const data = {
        invoices: [],
      };
      const error = {};
      if (data.success) {
        ErrorFatura(
          data.success.fault.erro.error,
          setDialogObject,
          setIsPhoneError,
          setLoading,
          setCurrentStep
        );
      } else if (data && data.invoices) {
        if (data.invoices.length === 0) {
          setIsEmpty(true);
          logger({ name: "HasNoInvoices" });
        } else {
          setInvoices(data.invoices);
          setIsEmpty(false);
          setCurrentStep(2);
          logger({ name: "HasInvoices" });
          window.hj("trigger", "Resultado_Fatura");
        }
      } else if (error) {
        ErrorFatura(
          error,
          setDialogObject,
          setIsPhoneError,
          setLoading,
          setCurrentStep
        );
      }
      //Sem Fatura
      else {
        setIsEmpty(true);
        logger({ name: "HasNoInvoices" });
      }
      setLoading(false);
    } else {
      acessarFaturas({
        msisdn,
        tokenRecaptcha,
        otpToken,
        otpTokenTrasactionId,
        isDev,
      })
        .then((response) => {
          return response.json();
        })
        .then(({ data, error }) => {
          if (data.success) {
            ErrorFatura(
              data.success.fault.erro.error,
              setDialogObject,
              setIsPhoneError,
              setLoading,
              setCurrentStep
            );
          } else if (data && data.invoices) {
            if (data.invoices.length === 0) {
              setIsEmpty(true);
              logger({ name: "HasNoInvoices" });
              reportGA4({
                event: "callback",
                customTitle: "fatura",
                customCallback: "sucesso:cliente_sem_faturas_em_aberto",
              });
            } else {
              setInvoices(data.invoices);
              setIsEmpty(false);
              setCurrentStep(2);
              logger({ name: "HasInvoices" });
              reportGA4({
                event: "callback",
                customTitle: "fatura",
                customCallback: "sucesso:cliente_com_faturas_em_aberto",
              });
              window.hj("trigger", "Resultado_Fatura");
            }
          } else if (error) {
            reportGA4({
              event: "callback",
              customTitle: "validacao_do_token",
              customCallback: "erro",
            });
            ErrorFatura(
              error,
              setDialogObject,
              setIsPhoneError,
              setLoading,
              setCurrentStep
            );
          }
          //Sem Fatura
          else {
            setIsEmpty(true);
            logger({ name: "HasNoInvoices" });
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setDialogObject({
            title: "Código de segurança",
            description: ["O Código de autorização é inválido."],
            function: () => {
              setDialogObject({
                title: "",
                description: [""],
                function: () => {},
                isOpen: false,
              });
            },
            isOpen: true,
          });
          reportGA4({
            event: "callback",
            customTitle: "validacao_do_token",
            customCallback: "erro:codigo_invalido",
          });
          logger({ name: "ErrorInvalidoToken", error: "Codigo Invalido" });
        });
    }
  };

  const handleCodeAuthentication = (
    msisdn,
    tokenRecaptcha,
    reSendToken = false
  ) => {
    setMsisdn(msisdn);
    setNew(true);
    setLoading(true);
    sendTokenCode({ msisdn, tokenRecaptcha, isDev })
      .then(async (response) => {
        reportGA4({
          event: "callback",
          customTitle: "validacao_do_numero",
          customCallback: "sucesso",
        });
        const isJson = response.headers
          .get("content-type")
          ?.includes("application/json");
        const data = isJson && (await response.json());
        if (response.status === 202 && data.transactionId) {
          setTokenRecaptcha(tokenRecaptcha);
          setOtpTransactionId(data.transactionId);
          setLoading(false);
          if (!reSendToken) {
            setCurrentStep(currentStep + 1);
          }
        } else if (isDev) {
          setInvoices(faturaInvoicesMockup);
          setMsisdn("(11)998774947");
          setCurrentStep(2);
          setIsEmpty(false);
          setLoading(false);
        } else {
          setCurrentStep(currentStep + 1);
          setIsPhoneError(true);
          setLoading(false);
          logger({ name: "ErrorOpenModalToken" });
        }
        setDialogObject({
          title: "",
          description: [""],
          function: () => {},
          isOpen: false,
        });
      })
      .catch((error) => {
        reportGA4({
          event: "callback",
          customTitle: "validacao_do_numero",
          customCallback: "erro",
        });
        if (isDev) {
          setInvoices(faturaInvoicesMockup);
          setMsisdn("(11)998774947");
          setCurrentStep(2);
          setIsEmpty(false);
          setLoading(false);
        } else {
          setCurrentStep(currentStep + 1);
          setIsPhoneError(true);
          setLoading(false);
          logger({ name: "ErrorOpenModalToken" });
        }
      });
  };

  const propsContainer = { isLoading, setLoading };

  const authenticationStepProps = {
    onClickHandleCodeAuthentication: (msisdn, tokenRecaptcha, reSendToken) => {
      handleCodeAuthentication(msisdn, tokenRecaptcha, reSendToken);
    },
    tokenRecaptcha: tokenRecaptcha,
    otpTransactionId: otpTransactionId,
    msisdn: lineSelected,
    onClickHandleValidate: (
      msisdn,
      tokenRecaptcha,
      otpToken,
      otpTokenTrasactionId
    ) =>
      handleAcessarFaturas(
        msisdn,
        tokenRecaptcha,
        otpToken,
        otpTokenTrasactionId
      ),
    onClickBackStep: () => setCurrentStep(currentStep - 1),
    isError: isPhoneError,
    setDialogObject,
  };

  const propsFaturaForm = {
    currentStep,
    isEmpty,
    handleCodeAuthentication,
    authenticationStepProps: authenticationStepProps,
    handleButtonVoltar,
    listInvoices,
    isPhoneError,
    lineSelected,
    changeNumberMsisdn: changeNumber,
  };

  React.useEffect(() => {
    if (listInvoices.length > 0 && isNew) {
      const arrayOld = listInvoices;
      const arrayNew = [];
      arrayOld.map((o) => {
        arrayNew.push({
          value: o.paymentDueDate,
          label: `${handleMesMask(o.paymentDueDate.split("-")[1])} • ${
            o.paymentDueDate.split("-")[0]
          }`,
          ...o,
        });
      });
      setNew(false);
      setInvoices(arrayNew);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listInvoices]);

  function changeNumber() {
    setMsisdn("");
    handleButtonVoltar();
  }

  return (
    <PageContainer {...propsContainer}>
      <Dialog
        title={dialogObject.title}
        description={dialogObject.description}
        isOpen={dialogObject.isOpen}
        onClick={dialogObject.function}
        botao={dialogObject.botao ?? undefined}
      />
      <FaturaForm {...propsFaturaForm} />
    </PageContainer>
  );
};

export default PageFaturaFacil;
